import MyCommissions from './MyCommissions';

export default MyCommissions;
